import checks from './checks';

const clone = (x, deep = true) => {
	if (checks.isArray()(x)) {
		return x.map(item => {
			if (deep) {
				return clone(item, true);
			} else {
				return item;
			}
		});
	}
	if (checks.isObject()(x)) {
		return Object.keys(x).reduce((acc, item) => {
			acc[item] = deep ? clone(x[item], true) : x[item];
			return acc;
		}, {});
	}
	return x;
};

const cloneRemoveByKeys = (x, keys, deep = true) => {
	if (checks.isArray()(x)) {
		return x.reduce((acc, item, index) => {
			if (!keys.includes(index)) {
				acc.push(deep ? clone(item, true) : item);
			}
			return acc;
		}, []);
	}
	if (checks.isObject()(x)) {
		return Object.keys(x).reduce((acc, item) => {
			if (!keys.includes(item)) {
				acc[item] = deep ? clone(x[item], true) : x[item];
			}
			return acc;
		}, {});
	}
	return x;
};

const cloneRemoveByValues = (x, value, deep = true) => {
	if (checks.isArray()(x)) {
		return x.reduce((acc, item) => {
			if (!value.includes(item)) {
				acc.push(deep ? clone(item, true) : item);
			}
			return acc;
		}, []);
	}
	if (checks.isObject()(x)) {
		return Object.keys(x).reduce((acc, item) => {
			if (!value.includes(x[item])) {
				acc[item] = deep ? clone(x[item], true) : x[item];
			}
			return acc;
		}, {});
	}
	return x;
};

// exports

export default {
	clone () { return clone },
	cloneRemoveByKeys () { return cloneRemoveByKeys },
	cloneRemoveByValues () { return cloneRemoveByValues }
};
